import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { FlagService } from '../../core/flag.service';
import {AuthService} from "../../ajs-upgraded-providers";

@Component({
  selector: 'rl-annotations-pills',
  templateUrl : './annotations-pills.component.html',
  styleUrls: ['./annotations-pills.component.scss']
})
export class AnnotationsPillsComponent implements OnInit, OnChanges {

  @Output() annotationSwitch = new EventEmitter<string>();
  @Input() allowAnnotations : boolean = true;
  @ViewChild('tabs', { static: false }) tabs?: TabsetComponent;
  displayAnnotations: boolean = true;

  constructor(private flagService: FlagService, private authService : AuthService) {}

  ngOnInit() {
    this.displayAnnotations = this.flagService.isDisplayAnnottaionToggel() && !this.authService.isGuest();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.allowAnnotations && changes.allowAnnotations.previousValue === true && changes.allowAnnotations.currentValue === false) {
      this.tabs.tabs[0].active = true;
    }
  }

  switchAnnotations(type, event) {
    this.annotationSwitch.emit(type);
  }

}
